import styled from "styled-components"

export const ErrorMessage = styled.div`
    margin: auto;
    text-align: center;
    font-size: 14px;
    color: ${p => p.theme.errorPage.text}
`